import React, {Component} from 'react';

class NatCom extends Component {

   render(){ 
    var nature = require.context("../../../public/images/Photography/Nature/", false, /.*\.jpg$/);
    console.log(nature.keys())
  return (
    
    <div class="phs1-item">
    <div class="phs1-container">
        <div class="phs1-item">
        {nature.keys().map((imgs)=>
            <img src={process.env.PUBLIC_URL + "/images/Photography/Nature/" + imgs.split("/").pop() } class="phs1-img"/>
        )}
        </div>
    </div>
    </div>
  );
}
}
export default NatCom;
